<div class="general">
    <div class="text-area">
        <h1>MUITO OBRIGADO PELO SEU FEEDBACK!!</h1>
        <h2>VOCÊ JÁ RESPONDEU ESSA PESQUISA.</h2>
    </div>
</div>
